import LayoutContainer from "../../components/Containers/LayoutContainer";
import QuizData from "./QuizData";

const Quiz = () => {
  return (
    <LayoutContainer title="Quiz">
      <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Quiz Folder
        </h2>
      </div>
      <QuizData />
    </LayoutContainer>
  );
};

export default Quiz;
